/**
 * Build Information
 * 
 * Informações do build para debug e verificação de versão.
 * O BUILD_ID é gerado em tempo de build pelo Vite (via define).
 * Se não estiver definido, usa timestamp de runtime como fallback.
 */

// BUILD_ID injetado pelo Vite em tempo de build
// Formato: YYYYMMDDHHMMSS-HASH (ex: 20260129140000-a1b2c3d4)
declare const __BUILD_ID__: string | undefined;

// Build ID: usa injeção do Vite ou fallback para timestamp
export const BUILD_ID = typeof __BUILD_ID__ !== 'undefined' 
  ? __BUILD_ID__ 
  : `dev-${new Date().toISOString().replace(/[-:T.Z]/g, '').slice(0, 14)}`;

// Versão semântica do app (incrementar manualmente antes de publicar)
// Regra: após X.Y.9 → X.Y+1.0, após X.9.9 → X+1.0.0
export const APP_VERSION = '2.21.9';
/**
 * Compara duas versões semânticas
 * @returns positivo se a > b, negativo se a < b, zero se iguais
 */
export function compareVersions(a: string, b: string): number {
  const parseVersion = (v: string) => {
    const [major = 0, minor = 0, patch = 0] = v.split('.').map(Number);
    return { major, minor, patch };
  };
  
  const va = parseVersion(a);
  const vb = parseVersion(b);
  
  if (va.major !== vb.major) return va.major - vb.major;
  if (va.minor !== vb.minor) return va.minor - vb.minor;
  return va.patch - vb.patch;
}

// Log no console em produção e desenvolvimento
console.log(`[StandFull] Build: ${BUILD_ID} | Version: ${APP_VERSION}`);
